import { useState, useEffect } from 'react';
import { Modal, Col, Row, Form, Input, message, Spin, Button } from 'antd';
import { format } from 'rut.js';
import {
  getChildCompany,
  updateChildCompany,
  createChildCompany,
  getTributaryCompany,
} from '../../../services/general';
import { useTranslation } from 'react-i18next';
import { DocumentCard } from 'cmt-ui-kit';
import { getCookie } from './../../../services/cookies';
const errorList = require('../../../utils/errorsList.json');

const ChildCompanyModal = ({
  childCompanyModal,
  setChildCompanyModal,
  addChildCompany,
  reservationForm,
  companyId
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState({ submit: false, fetch: false });
  const { t } = useTranslation();
  const countryCode = getCookie('country_code')
  const [documentType, setDocumentType] = useState(countryCode === 'CL' ? 'rut' : 'dni');
  useEffect(() => {
    if (childCompanyModal && form) {
      form.resetFields();
      if (childCompanyModal.type === 'edit') {
        fetchChildCompany();
      } else {
        const _documentType = countryCode === 'CL' ? 'rut' : 'ruc'
        form.setFieldsValue({ 'documentType': _documentType });
        setDocumentType(_documentType);
      }
    }
  }, [childCompanyModal.visible])

  const fetchChildCompany = async () => {
    setLoading({ ...loading, fetch: true });
    const response = await getChildCompany({
      id: reservationForm.getFieldValue('child_company_id')
    });
    form.setFieldsValue({
      'id': response.id,
      'documentNumber': response.document_type === 'rut' ? format(response.document_number) : response.document_number,
      'documentType': response.document_type,
      'businessName': response.business_name,
      'fantasyName': response.fantasy_name,
    })
    setLoading({ ...loading, fetch: false });
  }

  const closeModal = () => {
    form.resetFields();
    setChildCompanyModal({ ...childCompanyModal, visible: false });
  };

  const submit = () => {
    let responsePromise;

    form
      .validateFields()
      .then(() => {
        setLoading({ ...loading, submit: true });
        const values = form.getFieldsValue();
        values['document_type'] = values['documentType'];
        values['document_number'] = values['documentType'] === 'rut' ? format(values['documentNumber'], { dots: false }) : values['documentNumber'];
        delete values['documentType'];
        delete values['documentNumber'];
        values['companyId'] = companyId;

        if (values.id) {
          responsePromise = updateChildCompany(values.id, values);
        } else {
          responsePromise = createChildCompany(values);
        }

        responsePromise.then(response => {
          if (response.status === "error") {
            message.error(Object.values(response.data)[0]);
          } else {
            addChildCompany({
              business_name: response.business_name,
              id: response.id
            });

            reservationForm.setFieldsValue({
              child_company_id: response.id
            });

            message.success({
              content: `Sub Compañía ${childCompanyModal.type === 'edit' ? 'actualizada' : 'creada'} exitosamente`,
              style: {
                marginTop: '40vh',
              },
            });
          }
        }).catch((e) => {
          var errorMessage = 'Error interno ';

          if (!e.error) {
            const errorRes = JSON.parse(e);
            errorMessage = errorList[errorRes.code];
          }
          else {
            errorMessage = e.error.message;
          }

          message.error({
            content: errorMessage,
            style: {
              marginTop: '40vh',
            },
          });

        }).finally(() => {
          setLoading({ ...loading, submit: false });
          closeModal();
        });
      });
  }

  const handleDocumentNumber = async event => {
    let inputValue = documentType === 'rut' ? format(event.target.value, { dots: false }) : event.target.value;
    if ((documentType === 'ruc' && inputValue.length === 11)
      || (documentType === 'rut' && inputValue.length > 6)) {
      const response = await getTributaryCompany({
        document_number: inputValue,
        document_type: documentType,
      });
      if (response && response.business_name) {
        form.setFieldsValue({
          businessName: response.business_name,
        })
      }
    }
  };


  return (
    <Modal
      forceRender
      className="creation-modal"
      open={childCompanyModal.visible}
      onCancel={closeModal}
      footer={false}
      closable
    >
      <Spin className='cmt-spin' spinning={loading.fetch}>
        <Form form={form} layout="vertical">
          <Row>
            <Col lg={24} xs={24}>
              <h1 className='text-center mb-20'>
                {childCompanyModal.type === 'create' ? 'Nueva Sub Compañía' : 'Editar Sub Compañía'}
              </h1>
            </Col>
            <Col lg={24} xs={24}>
              <Row gutter={[15, 15]}>
                <Col lg={16} xs={24}>
                  <Form.Item name="id" hidden>
                    <Input type="hidden" />
                  </Form.Item>
                  <Row>
                    <Col lg={24} xs={24}>
                      <p>{t('reservations.childCompanyModal.documentNumberLabel')}</p>
                    </Col>
                    <Col lg={24} xs={24}>
                      <DocumentCard
                        countryCode={countryCode}
                        setDocumentType={setDocumentType}
                        form={form}
                        handleOnDocumentNumberBlur={handleDocumentNumber}
                        type='company'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name="businessName"
                    label={t('reservations.childCompanyModal.companyLabel')}
                    rules={[{ required: true, message: 'Este campo es requerido' }]}
                  >
                    <Input disabled={childCompanyModal.type === 'edit'} className="cmt-input" placeholder='Ingrese nombre de compañía' />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name="fantasyName"
                    label={t('reservations.childCompanyModal.fantasyNameLabel')}
                  >
                    <Input className="cmt-input" placeholder='Ingrese nombre de fantasía' />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify='center' gutter={[15, 15]} className='mt-40'>
                <Col lg={8} xs={24}>
                  <Button
                    disabled={loading.submit}
                    className='cmt-button primary outline'
                    type='primary'
                    onClick={closeModal}
                  >
                    Cancelar
                  </Button>
                </Col>
                <Col lg={12} xs={24}>
                  <Button
                    loading={loading.submit}
                    disabled={loading.submit}
                    className='cmt-button primary'
                    type='primary'
                    onClick={submit}
                  >
                    {childCompanyModal.type === 'create' ? 'Crear Sub Compañía' : 'Actualizar Sub Compañía'}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal >
  )
}

export default ChildCompanyModal;
